const initialState = {
  description: '',
  amount: 0,
  ui: {
    is_submitting: false,
    is_deleting: false,
    show: false,
  },
  errors:[],
}

export default function(state=initialState, action){
  switch(action.type){
    case "REFRESH_EDIT_PENDING_INVOICE":
      return {
        ...state,
        ...action.payload,
      }
    case "FAILED_SUBMIT_UPDATE_PENDING_INVOICE":
    case "FAILED_SUBMIT_DELETE_PENDING_INVOICE":
      return {
        ...state,
        ui: {
          ...state.ui,
          is_deleting: false,
          is_submitting: false,
        },
        errors: [
          ...action.payload
        ]
      }
    case "SUCCESS_SUBMIT_DELETE_PENDING_INVOICE":
      return initialState
    case "BEGIN_SUBMIT_DELETE_PENDING_INVOICE":
      return {
        ...state,
        ui: {
          ...state.ui,
          is_deleting: true
        }
      }
    case "SUCCESS_SUBMIT_UPDATE_PENDING_INVOICE":
      return initialState
    case "BEGIN_SUBMIT_UPDATE_PENDING_INVOICE":
      return {
        ...state,
        ui: {
          ...state.ui,
          is_submitting: true
        }
      }
    case "RESET_EDIT_PENDING_INVOICE":
      return initialState;
    case "LOAD_EDIT_PENDING_INVOICE":
      return {
        ...state,
        ...action.payload,
        ui: {
          ...state.ui,
          show: true,
        }
      }
    case "UPDATE_EDIT_PENDING_INVOICE_UI":
     return {
        ...state,
        ui: {
          ...state.ui,
          ...action.payload,
        }
     }
    case "UPDATE_EDIT_PENDING_INVOICE_FIELD":
      return {
        ...state,
        ...action.payload
      }
    default:
      return state
  }
}